module.exports = __webpack_public_path__ + "img/select-lock-position.91470602.png";